import { render, staticRenderFns } from "./IconSelfCommon.vue?vue&type=template&id=56186f90"
import script from "./IconSelfCommon.vue?vue&type=script&lang=js"
export * from "./IconSelfCommon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports